<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form autocomplete="off" method="post">
      <b-button
        v-b-toggle.employeesSalarySettingData
        class="btn btn-lg btn-collapse"
      >
        {{ $t("employeesSalarySettingData") }}
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </b-button>
      <b-collapse id="employeesSalarySettingData">
        <div class="my-card">
          <div class="row">
            <TextArea
              :className="'col-md-6 col-lg-4'"
              :id="'employeeSalarySettingDescriptionAr'"
              :value="
                employeeSalarySettingData.employeeSalarySettingDescriptionAr
              "
              v-on:changeValue="
                employeeSalarySettingData.employeeSalarySettingDescriptionAr =
                  $event
              "
              :title="$t('employeeSalarySettingDescriptionAr')"
              :imgName="'employee-salary-setting.svg'"
            />
            <TextArea
              :className="'col-md-6 col-lg-4'"
              :id="'employeeSalarySettingDescriptionEn'"
              :value="
                employeeSalarySettingData.employeeSalarySettingDescriptionEn
              "
              v-on:changeValue="
                employeeSalarySettingData.employeeSalarySettingDescriptionEn =
                  $event
              "
              :title="$t('employeeSalarySettingDescriptionEn')"
              :imgName="'employee-salary-setting.svg'"
            />
            <TextArea
              :className="'col-md-6 col-lg-4'"
              :id="'employeeSalarySettingDescriptionUnd'"
              :value="
                employeeSalarySettingData.employeeSalarySettingDescriptionUnd
              "
              v-on:changeValue="
                employeeSalarySettingData.employeeSalarySettingDescriptionUnd =
                  $event
              "
              :title="$t('employeeSalarySettingDescriptionUnd')"
              :imgName="'employee-salary-setting.svg'"
            />

            <CustomInputFloat
              :className="'col-md-6 col-lg-4'"
              :id="'employeeBasicSalary'"
              :value="employeeSalarySettingData.employeeBasicSalary"
              v-on:changeValue="
                employeeSalarySettingData.employeeBasicSalary = $event
              "
              :title="$t('employeeBasicSalary')"
              :imgName="'money.svg'"
            />
            <CustomInputFloat
              :className="'col-md-6 col-lg-4'"
              :id="'employeeVariableSalary'"
              :value="employeeSalarySettingData.employeeVariableSalary"
              v-on:changeValue="
                employeeSalarySettingData.employeeVariableSalary = $event
              "
              :title="$t('employeeVariableSalary')"
              :imgName="'money.svg'"
            />
            <DataLabelGroup
              :className="'col-md-6 col-lg-4'"
              :value="
                parseFloat(
                  employeeSalarySettingData.employeeBasicSalary
                    ? employeeSalarySettingData.employeeBasicSalary
                    : 0
                ) +
                parseFloat(
                  employeeSalarySettingData.employeeVariableSalary
                    ? employeeSalarySettingData.employeeVariableSalary
                    : 0
                )
              "
              :title="$t('employeeTotalSalary')"
              :imgName="'money.svg'"
            />

            <TimeCounter
              @input="
                employeeSalarySettingData.employeeWorkDaysNumberPerMonth =
                  $event.days
              "
              :dayValue="
                employeeSalarySettingData.employeeWorkDaysNumberPerMonth
              "
              :className="'col-md-6 col-lg-4'"
              :title="$t('employeeWorkDaysNumberPerMonth')"
              :imgName="'days.svg'"
              :dayEnd="MAX_MONTH_DAYS"
              :dayStatus="true"
              :hourStatus="false"
              :minuteStatus="false"
              :secondStatus="false"
            />
            <TimeCounter
              @input="
                employeeSalarySettingData.employeeWorkHoursNumberPerDay =
                  $event.value;
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime.hours =
                  $event.hours;
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime.minutes =
                  $event.minutes;
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime.seconds =
                  $event.seconds;
              "
              :hourValue="
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime
                  .hours
              "
              :minuteValue="
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime
                  .minutes
              "
              :secondValue="
                employeeSalarySettingData.employeeWorkHoursNumberPerDayTime
                  .seconds
              "
              :className="'col-md-6 col-lg-4'"
              :title="$t('employeeWorkHoursNumberPerDay')"
              :imgName="'hours.svg'"
              :dayStatus="false"
            />
            <CustomSelectBox
              :className="'col-md-6 col-lg-4'"
              :id="'employeeInsuranceTypeToken'"
              :value="employeeSalarySettingData.employeeInsuranceTypeToken"
              :options="employeeInsuranceTypeTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeInsuranceTypeToken = $event
              "
              :title="$t('selectInsuranceType')"
              :imgName="'type.svg'"
            />

            <CustomInputFloat
              :className="'col-md-6 col-lg-4'"
              :id="'employeeWorkHourPrice'"
              :value="employeeSalarySettingData.employeeWorkHourPrice"
              v-on:changeValue="
                employeeSalarySettingData.employeeWorkHourPrice = $event
              "
              :title="$t('employeeWorkHourPrice')"
              :imgName="'money.svg'"
            />
            <CustomInputFloat
              :className="'col-md-6 col-lg-4'"
              :id="'employeePriceUnKnownWorkhour'"
              :value="employeeSalarySettingData.employeePriceUnKnownWorkhour"
              v-on:changeValue="
                employeeSalarySettingData.employeePriceUnKnownWorkhour = $event
              "
              :title="$t('employeePriceUnKnownWorkhour')"
              :imgName="'money.svg'"
            />
            <CustomCheckbox
              :className="'col-md-6 col-lg-4'"
              :value="
                employeeSalarySettingData.employeeSalarySettingActivationStatus
              "
              v-on:changeValue="
                employeeSalarySettingData.employeeSalarySettingActivationStatus =
                  $event
              "
              :title="$t('employeeSalarySettingActivationStatus')"
            />

            <div class="my-card col-md-12">
              <span class="my-card-title">{{
                $t("maximumAllowedOverTimeInMonth")
              }}</span>

              <div class="row">
                <TimeCounter
                  @input="
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByHours24 =
                      $event.days
                  "
                  :dayValue="
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByHours24
                  "
                  :className="'col-md-6 col-lg-4'"
                  :title="$t('day')"
                  :imgName="'days.svg'"
                  :dayEnd="MAX_MONTH_DAYS"
                  :dayStatus="true"
                  :hourStatus="false"
                  :minuteStatus="false"
                  :secondStatus="false"
                />
                <TimeCounter
                  @input="
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByDays =
                      $event.value;
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByDaysTime.hours =
                      $event.hours;
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByDaysTime.minutes =
                      $event.minutes;
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthByDaysTime.seconds =
                      $event.seconds;
                  "
                  :hourValue="
                    employeeSalarySettingData
                      .employeeMaximumAllowedOverTimeInMonthByDaysTime.hours
                  "
                  :minuteValue="
                    employeeSalarySettingData
                      .employeeMaximumAllowedOverTimeInMonthByDaysTime.minutes
                  "
                  :secondValue="
                    employeeSalarySettingData
                      .employeeMaximumAllowedOverTimeInMonthByDaysTime.seconds
                  "
                  :className="'col-md-6 col-lg-4'"
                  :title="$t('time')"
                  :imgName="'hours.svg'"
                  :dayStatus="false"
                />

                <CustomCheckbox
                  :className="'col-lg-4'"
                  :value="
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthStatus
                  "
                  v-on:changeValue="
                    employeeSalarySettingData.employeeMaximumAllowedOverTimeInMonthStatus =
                      $event
                  "
                  :title="$t('activationStatus')"
                />
              </div>
            </div>

            <div class="my-card col-md-12">
              <span class="my-card-title">{{
                $t("maximumAllowedShiftAbsenceUntillSalaryStop")
              }}</span>

              <div class="row">
                <CustomInputInt
                  :className="'col-md-6'"
                  :id="'employeeMaximumAllowedShiftAbsenceUntillSalaryStop'"
                  :value="
                    employeeSalarySettingData.employeeMaximumAllowedShiftAbsenceUntillSalaryStop
                  "
                  v-on:changeValue="
                    employeeSalarySettingData.employeeMaximumAllowedShiftAbsenceUntillSalaryStop =
                      $event
                  "
                  :title="$t('theNumber')"
                  :imgName="'number.svg'"
                />

                <CustomCheckbox
                  :className="'col-md-6'"
                  :value="
                    employeeSalarySettingData.employeeMaximumAllowedShiftAbsenceUntillSalaryStopStatus
                  "
                  v-on:changeValue="
                    employeeSalarySettingData.employeeMaximumAllowedShiftAbsenceUntillSalaryStopStatus =
                      $event
                  "
                  :title="$t('activationStatus')"
                />
              </div>
            </div>

            <CustomSelectBox
              :className="'col-md-6'"
              :id="'employeeBalancePlanToken'"
              :value="employeeSalarySettingData.employeeBalancePlanToken"
              :options="employeeBalancesPlansTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeBalancePlanToken = $event
              "
              :title="$t('selectBalancesPlan')"
              :imgName="'balances-plans.svg'"
            />
            <CustomSelectBox
              :className="'col-md-6'"
              :id="'employeeAbsencePlanToken'"
              :value="employeeSalarySettingData.employeeAbsencePlanToken"
              :options="employeeAbsencePlansTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeAbsencePlanToken = $event
              "
              :title="$t('selectAbsencePlan')"
              :imgName="'absence-plans.svg'"
            />
            <CustomSelectBox
              :className="'col-md-6'"
              :id="'employeeAllowancePlanToken'"
              :value="employeeSalarySettingData.employeeAllowancePlanToken"
              :options="employeeAllowancesPlansTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeAllowancePlanToken = $event
              "
              :title="$t('selectAllowancesPlan')"
              :imgName="'allowances-plans.svg'"
            />
            <CustomSelectBox
              :className="'col-md-6'"
              :id="'employeeMonthAllowancesPlanToken'"
              :value="
                employeeSalarySettingData.employeeMonthAllowancesPlanToken
              "
              :options="employeeMonthAllowancesPlansTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeMonthAllowancesPlanToken =
                  $event
              "
              :title="$t('selectMonthAllowancesPlan')"
              :imgName="'month-allowances-plans.svg'"
            />

            <CustomSelectBox
              :className="'col-md-6'"
              :id="'employeeDeductionsPlanToken'"
              :value="employeeSalarySettingData.employeeDeductionsPlanToken"
              :options="employeeDeductionsPlansTokenOptions"
              v-on:changeValue="
                employeeSalarySettingData.employeeDeductionsPlanToken = $event
              "
              :title="$t('deductions.select')"
              :imgName="'deductions.svg'"
            />
            <TextArea
              :className="'col-md-6'"
              :id="'employeeSalarySettingNotes'"
              :value="employeeSalarySettingData.employeeSalarySettingNotes"
              v-on:changeValue="
                employeeSalarySettingData.employeeSalarySettingNotes = $event
              "
              :title="$t('notes')"
              :imgName="'notes.svg'"
            />
          </div>
        </div>
      </b-collapse>

      <div class="form-footer">
        <div v-if="submitName == $t('add')">
          <input
            type="checkbox"
            id="selectAll"
            @click="selectAll"
            v-model="allSelected"
            class="checkbox"
          />
          <label class="mt-1 ml-2" for="selectAll">{{ $t("selectAll") }}</label>
        </div>

        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="addOrUpdateEmployeeSalarySetting"
        >
          {{ submitName }}
        </button>

        <router-link
          v-if="submitName == $t('edit')"
          :to="`/employee-salary-settings/${employeeSalarySettingData.employeeToken}`"
          class="btn btn-cancel"
        >
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>

    <div v-if="employeesData && submitName == $t('add')">
      <div class="row">
        <div
          class="flip-card col-12 col-sm-6 col-md-4 col-lg-3"
          v-for="employee in employeesData"
          :key="employee.employeeToken"
        >
          <div class="card-inner">
            <div class="card-front">
              <div class="flip-card-title-top">
                <h6 class="cut-1line">{{ employee.employeeCode }}</h6>
              </div>
              <img
                :src="baseUrl + employee.employeeImagePath"
                :onerror="`this.src='${defaultImg}'`"
                alt="Image"
              />
              <div class="flip-card-title">
                <h4 class="cut-1line">
                  {{
                    language == "ar"
                      ? employee.employeeNameAr
                      : employee.employeeNameEn
                  }}
                </h4>
              </div>
              <input
                type="checkbox"
                v-model="employeeSalarySettingData.employeeTokenList"
                @click="select"
                :value="employee.employeeToken"
                class="checkbox item-right-top"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <EmployeeFloatBtns
      v-if="submitName == $t('add')"
      :filterOnly="true"
      :textSearch="textSearch"
      v-on:search="search"
    />
  </div>
</template>

<script>
import {
  STATUS,
  BASE_URL,
  DEFAULT_IMG,
  MAX_MONTH_DAYS,
} from "@/utils/constants";
import { setDataMultiLang } from "@/utils/functions";
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import axios from "axios";
import CustomInputFloat from "@/components/general/CustomInputFloat.vue";
import CustomInputInt from "@/components/general/CustomInputInt.vue";
import TimeCounter from "@/components/general/TimeCounter.vue";
import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import CustomCheckbox from "@/components/general/CustomCheckbox.vue";
import TextArea from "@/components/general/TextArea.vue";
import BalancesPlan from "@/models/settings/settingsSalary/balancesPlans/BalancesPlan";
import AllowancesPlan from "@/models/settings/settingsSalary/allowancesPlans/AllowancesPlan";
import MonthAllowancesPlan from "@/models/settings/settingsSalary/monthAllowancesPlans/MonthAllowancesPlan";
import AbsencePlan from "@/models/settings/settingsSalary/absencePlans/AbsencePlan";
import DeductionsPlan from "@/models/settings/settingsSalary/deductionsPlans/DeductionsPlan";
import EmployeeFloatBtns from "@/components/employees/employees/EmployeeFloatBtns.vue";

export default {
  name: "EmployeeSalarySettingForm",
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomInputFloat,
    CustomInputInt,
    TimeCounter,
    DataLabelGroup,
    CustomSelectBox,
    CustomCheckbox,
    TextArea,
    EmployeeFloatBtns,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      textSearch: "",
      typeToken: "",
      baseUrl: BASE_URL,
      defaultImg: DEFAULT_IMG,
      employeesData: null,
      allSelected: false,
      employeeTokenList: [],

      balancesPlanData: new BalancesPlan(),
      absencePlanData: new AbsencePlan(),
      allowancesPlanData: new AllowancesPlan(),
      monthAllowancesPlanData: new MonthAllowancesPlan(),
      overTimePlanData: new DeductionsPlan(),
      employeeBalancesPlansTokenOptions: [],
      employeeAbsencePlansTokenOptions: [],
      employeeAllowancesPlansTokenOptions: [],
      employeeMonthAllowancesPlansTokenOptions: [],
      employeeDeductionsPlansTokenOptions: [],
      employeeInsuranceTypeTokenOptions: [],
      MAX_MONTH_DAYS,
    };
  },
  props: ["employeeSalarySettingData", "submitName"],
  methods: {
    selectAll() {
      this.allSelected = !this.allSelected;
      this.employeeSalarySettingData.employeeTokenList = [];

      if (this.allSelected) {
        for (let employee in this.employeesData) {
          this.employeeSalarySettingData.employeeTokenList.push(
            this.employeesData[employee].employeeToken
          );
        }
      }
    },
    select() {
      if (
        this.employeesData.length ==
        this.employeeSalarySettingData.employeeTokenList.length
      )
        this.allSelected = true;
      else this.allSelected = false;
    },
    search(text, employeeTypeToken) {
      this.textSearch = text;
      this.typeToken = employeeTypeToken;
      this.getAllEmployees();
    },
    async addOrUpdateEmployeeSalarySetting() {
      this.$emit("addOrUpdateEmployeeSalarySetting");
    },
    async getDialogOfInsuranceTypes() {
      this.employeeInsuranceTypeTokenOptions = [];
      // this.employeeInsuranceTypeTokenOptions.push({
      //   value: "",
      //   text: this.$t("selectInsuranceType"),
      // });
      let list = this.$store.getters.userData.constantLists.listInsuranceType;
      for (let item in list) {
        this.employeeInsuranceTypeTokenOptions.push({
          value: list[item]["itemToken"],
          text: setDataMultiLang(
            this.language,
            list[item]["itemNameAr"],
            list[item]["itemNameEn"]
          ),
        });
      }
    },
    async getDialogOfBalancesPlans() {
      this.isLoading = true;
      this.employeeBalancesPlansTokenOptions = [];
      this.employeeBalancesPlansTokenOptions.push({
        value: "",
        text: this.$t("selectBalancesPlan"),
      });
      try {
        let response = await this.balancesPlanData.getDialogOfBalancesPlans(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeBalancesPlansTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfAbsencePlans() {
      this.isLoading = true;
      this.employeeAbsencePlansTokenOptions = [];
      this.employeeAbsencePlansTokenOptions.push({
        value: "",
        text: this.$t("selectAbsencePlan"),
      });
      try {
        let response = await this.absencePlanData.getDialogOfAbsencePlans(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeAbsencePlansTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfAllowancesPlans() {
      this.isLoading = true;
      this.employeeAllowancesPlansTokenOptions = [];
      this.employeeAllowancesPlansTokenOptions.push({
        value: "",
        text: this.$t("selectAllowancesPlan"),
      });
      try {
        let response = await this.allowancesPlanData.getDialogOfAllowancesPlans(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeAllowancesPlansTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfMonthAllowancesPlans() {
      this.isLoading = true;
      this.employeeMonthAllowancesPlansTokenOptions = [];
      this.employeeMonthAllowancesPlansTokenOptions.push({
        value: "",
        text: this.$t("selectMonthAllowancesPlan"),
      });
      try {
        let response =
          await this.monthAllowancesPlanData.getDialogOfMonthAllowancesPlans(
            this.language,
            this.userAuthorizeToken
          );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeMonthAllowancesPlansTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfDeductionsPlans() {
      this.isLoading = true;
      this.employeeDeductionsPlansTokenOptions = [];
      this.employeeDeductionsPlansTokenOptions.push({
        value: "",
        text: this.$t("deductions.select"),
      });
      try {
        let response = await this.overTimePlanData.getDialogOfDeductionsPlans(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeDeductionsPlansTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getAllEmployees() {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `/Employees/GetAllEmployees?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}&paginationStatus=false&employeeTypeToken=${this.typeToken}&filterStatus=true&textSearch=${this.textSearch}`
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.employeesData = response.data.employeesPagination.employeesData;
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.employeesData = null;
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.employeesData = null;
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.employeesData = null;
          this.exceptionMsg = response.data.msg;
          this.showMsg(response.data.msg);
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.employeesData = null;
      }
      this.isLoading = false;
    },
  },
  watch: {
    employeeTokenList: function (val) {
      if (this.employeesData.length == val.length) this.allSelected = true;
      else this.allSelected = false;
    },
  },
  async created() {
    if (this.submitName == this.$t("add")) this.getAllEmployees();
    this.getDialogOfInsuranceTypes();
    this.getDialogOfBalancesPlans();
    this.getDialogOfAbsencePlans();
    this.getDialogOfAllowancesPlans();
    this.getDialogOfMonthAllowancesPlans();
    this.getDialogOfDeductionsPlans();
  },
};
</script>

<style lang="scss"></style>
